export const CyCrewSettings = {
  CrewList: "CrewList",
  LeaveCrewButton: "LeaveCrewButton",
  JoinCrewButton: "JoinCrewButton",
  CreateCrewButton: "CreateCrewButton",
  EditCrewButton: "EditCrewButton",
  DeleteCrewButton: "DeleteCrewButton",
  OrganizationButton: "OrganizationButton",
} as const;
